
import { Card } from "@/components/ui/card";

const SellerHelp = () => {
  return (
    <div className="container mx-auto px-4 py-6 max-w-2xl">
      <Card className="p-6">
        <p className="text-muted-foreground">Help and support content coming soon...</p>
      </Card>
    </div>
  );
};

export default SellerHelp;
